import React from 'react';
import { Headphones, Video, FileText, Users, Calendar } from 'lucide-react';
export function ProgramFeatures() {
  return <section id="programa" className="py-16 px-4 md:px-8 lg:px-16 bg-indigo-50" data-id="element-282">
      <div className="max-w-7xl mx-auto" data-id="element-283">
        <div className="text-center mb-16" data-id="element-284">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-indigo-900" data-id="element-285">
            ¿Qué Incluye El Programa 30 Días Frecuencia Prohibida?
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-286">
            Un sistema completo y estructurado para elevar tu frecuencia
            vibratoria en solo 30 días, con todo lo que necesitas para
            transformar tu energía desde el primer día.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16" data-id="element-287">
          <div className="bg-white p-8 rounded-lg shadow-lg" data-id="element-288">
            <img src="https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1920&q=80" alt="Módulos del programa" className="w-full h-64 object-cover rounded-lg mb-6" data-id="element-289" />
            <h3 className="text-2xl font-bold mb-4 text-indigo-900" data-id="element-290">
              4 Módulos Transformadores
            </h3>
            <ul className="space-y-4" data-id="element-291">
              <li className="flex items-start" data-id="element-292">
                <div className="bg-indigo-100 rounded-full w-8 h-8 flex items-center justify-center text-indigo-800 font-bold mr-3 mt-1" data-id="element-293">
                  1
                </div>
                <div data-id="element-294">
                  <h4 className="font-bold text-lg" data-id="element-295">Despertar Energético</h4>
                  <p className="text-gray-700" data-id="element-296">
                    Limpia bloqueos energéticos y prepara tu sistema para vibrar
                    a frecuencias superiores (7 días)
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-297">
                <div className="bg-indigo-100 rounded-full w-8 h-8 flex items-center justify-center text-indigo-800 font-bold mr-3 mt-1" data-id="element-298">
                  2
                </div>
                <div data-id="element-299">
                  <h4 className="font-bold text-lg" data-id="element-300">
                    Activación de Frecuencias Prohibidas
                  </h4>
                  <p className="text-gray-700" data-id="element-301">
                    Accede a frecuencias ancestrales que han sido ocultadas por
                    su inmenso poder transformador (8 días)
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-302">
                <div className="bg-indigo-100 rounded-full w-8 h-8 flex items-center justify-center text-indigo-800 font-bold mr-3 mt-1" data-id="element-303">
                  3
                </div>
                <div data-id="element-304">
                  <h4 className="font-bold text-lg" data-id="element-305">
                    Manifestación Consciente
                  </h4>
                  <p className="text-gray-700" data-id="element-306">
                    Aprende a utilizar tu nueva frecuencia para manifestar tus
                    deseos más profundos (8 días)
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-307">
                <div className="bg-indigo-100 rounded-full w-8 h-8 flex items-center justify-center text-indigo-800 font-bold mr-3 mt-1" data-id="element-308">
                  4
                </div>
                <div data-id="element-309">
                  <h4 className="font-bold text-lg" data-id="element-310">Integración y Expansión</h4>
                  <p className="text-gray-700" data-id="element-311">
                    Consolida tu nueva frecuencia y expande su impacto en todas
                    las áreas de tu vida (7 días)
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div className="space-y-6" data-id="element-312">
            <div className="bg-white p-6 rounded-lg shadow-lg flex" data-id="element-313">
              <div className="mr-4" data-id="element-314">
                <Headphones size={40} className="text-indigo-600" data-id="element-315" />
              </div>
              <div data-id="element-316">
                <h4 className="text-xl font-bold mb-2 text-indigo-900" data-id="element-317">
                  6 Audios de Frecuencias Transformadoras
                </h4>
                <p className="text-gray-700" data-id="element-318">
                  Audios transformadores simples de usar con frecuencias
                  específicas que elevan tu vibración. Escúchalos en cualquier
                  momento para obtener resultados inmediatos.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex" data-id="element-319">
              <div className="mr-4" data-id="element-320">
                <Video size={40} className="text-indigo-600" data-id="element-321" />
              </div>
              <div data-id="element-322">
                <h4 className="text-xl font-bold mb-2 text-indigo-900" data-id="element-323">
                  1 Masterclass Completa
                </h4>
                <p className="text-gray-700" data-id="element-324">
                  Una masterclass exclusiva de 1 hora de duración con
                  explicaciones detalladas de cada técnica y práctica para
                  maximizar los beneficios de las frecuencias.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex" data-id="element-325">
              <div className="mr-4" data-id="element-326">
                <FileText size={40} className="text-indigo-600" data-id="element-327" />
              </div>
              <div data-id="element-328">
                <h4 className="text-xl font-bold mb-2 text-indigo-900" data-id="element-329">
                  Cuaderno de Trabajo Digital
                </h4>
                <p className="text-gray-700" data-id="element-330">
                  Ejercicios diarios y registros para documentar tu
                  transformación y acelerar tus resultados. Solo 5-10 minutos al
                  día.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex" data-id="element-331">
              <div className="mr-4" data-id="element-332">
                <Users size={40} className="text-indigo-600" data-id="element-333" />
              </div>
              <div data-id="element-334">
                <h4 className="text-xl font-bold mb-2 text-indigo-900" data-id="element-335">
                  Comunidad Privada de Apoyo
                </h4>
                <p className="text-gray-700" data-id="element-336">
                  Acceso a un grupo exclusivo donde compartirás tu viaje con
                  otros participantes y recibirás apoyo constante.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg flex" data-id="element-337">
              <div className="mr-4" data-id="element-338">
                <Calendar size={40} className="text-indigo-600" data-id="element-339" />
              </div>
              <div data-id="element-340">
                <h4 className="text-xl font-bold mb-2 text-indigo-900" data-id="element-341">
                  Compromiso de Tiempo
                </h4>
                <p className="text-gray-700" data-id="element-342">
                  Solo 30 minutos al día para transformar completamente tu
                  frecuencia vibratoria y tu vida.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-343">
          <a href="#inscripcion" className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-4 px-8 rounded-lg text-lg transition-all transform hover:scale-105" data-id="element-344">
            Quiero Elevar Mi Frecuencia Ahora
          </a>
        </div>
      </div>
    </section>;
}